<mat-divider *ngIf="showDivider" class="!my-6"></mat-divider>
<div class="@container">
  <div class="flex items-center gap-3 mb-4">
    <h3 class="nomargin flex-1 mb-3" id="listing-markups">Listing markups</h3>
    <sbnb-save-indicator [saveStatus]="saveStatus$ | async"></sbnb-save-indicator>
  </div>

  <p class="text__small">
    Set the percentage to add to your nightly rate when updating prices, so you earn the same amount across channels
    after platform fees.
  </p>

  <div *ngIf="markupData$ | async as markupData">
    <ng-container *ngFor="let listing of propertyListings">
      <div
        *ngIf="listing.platform_key !== 'gvr' && listing.platform_key !== 'manual'"
        class="text__small flex flex-col @md:flex-row @md:items-center gap-2 mb-4">
        <div class="flex justify-between items-center gap-3 flex-1">
          <div class="flex-1 flex items-center gap-3">
            <sbnb-mini-listing-img [imgSrc]="listing.picture" imgWidth="26px" imgHeight="20px"></sbnb-mini-listing-img>
            <div class="flex flex-col">
              <strong class="truncate">{{ listing.name }}</strong>
              <div *ngIf="listing.location" class="hidden @md:flex">
                {{ listing.location }}
              </div>
            </div>
          </div>
          <sbnb-icon-platform
            [platform]="listing.platform_key"
            [size]="12"
            class="@md:hidden mr-[2px]"></sbnb-icon-platform>
        </div>

        <div class="flex items-center gap-3">
          <sbnb-icon-platform
            [platform]="listing.platform_key"
            [size]="12"
            class="hidden @md:block"></sbnb-icon-platform>
          <mat-form-field class="input__mini nomargin nopadding w-full @md:max-w-[120px]">
            <input
              class="nopadding nomargin"
              matInput
              type="tel"
              maxlength="7"
              [attr.placeholder]="markupData.platformMarkups | findMarkupByChannel: listing.platform_key"
              [value]="listing.listing_id | listingMarkup: markupData.propertyMarkups"
              (change)="listingMarkupChanged(listing, $event.target.value)" />
            <span matSuffix class="suffix-bg">%</span>
          </mat-form-field>
        </div>
      </div>
    </ng-container>
  </div>
</div>
